import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { getImageContextKey } from '@v2/components/imageHandling/helpers';
import { ImageContext } from '@v2/components/imageHandling/types/types';
import { useEffect } from 'react';
import { setCurrentContextKey } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';

export const useUpdateCurrentImageContext = (imageContext: ImageContext) => {
  const dispatch = useAppDispatch();
  const storeKey = getImageContextKey(imageContext);

  useEffect(() => {
    dispatch(setCurrentContextKey(storeKey));
  }, [storeKey, dispatch]);
};
